__turbopack_context__.v({
  "body": "_7LgenW_body",
  "button": "_7LgenW_button",
  "header": "_7LgenW_header",
  "root": "_7LgenW_root",
});
